import React, { useState, useEffect, useCallback } from 'react';

const RequestManagementView = ({ apiUrl, token }) => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchRequests = useCallback(async () => {
        setLoading(true);
        try {
            const res = await fetch(`${apiUrl}/api/getSheetData?sheetName=Movimientos&range=A2:G`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            // Filtrar solo las solicitudes pendientes
            const pendingRequests = data.filter(row => row[4] === 'Solicitud' && (!row[7] || row[7] === 'pending'));
            setRequests(pendingRequests);
        } catch (error) {
            console.error("Error fetching requests:", error);
            alert("Error al cargar los requerimientos.");
        } finally {
            setLoading(false);
        }
    }, [apiUrl, token]);

    useEffect(() => {
        fetchRequests();
    }, [fetchRequests]);

    const handleProcessRequest = async (movId, status, approvedQty = null) => {
        const action = status === 'approved' ? 'aprobar' : 'rechazar';
        if (!window.confirm(`¿Estás seguro de que quieres ${action} esta solicitud?`)) return;

        // 1. Actualizar el estado de la solicitud en Movimientos
        const updatedRow = requests.find(r => r[0] === movId);
        if (!updatedRow) return;
        updatedRow[7] = status; // Columna H (Status)
        if (approvedQty) {
            updatedRow[5] = approvedQty; // Actualizar cantidad si se modifica
        }

        await fetch(`${apiUrl}/api/updateRow`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ sheetName: 'Movimientos', rowIndex: requests.indexOf(updatedRow) + 2, rowData: updatedRow }),
        });

        // 2. Si se aprueba, descontar del stock
        if (status === 'approved') {
            const itemId = updatedRow[3];
            const qtyToDeduct = parseInt(updatedRow[5]);
            
            const stockRes = await fetch(`${apiUrl}/api/getSheetData?sheetName=Stock`, { headers: { 'Authorization': `Bearer ${token}` }});
            const stockData = await stockRes.json();
            const stockItem = stockData.slice(1).find(row => row[0] === itemId);

            if (stockItem) {
                const currentQty = parseInt(stockItem[2]);
                const newQty = currentQty - qtyToDeduct;
                const updatedStockRow = [...stockItem];
                updatedStockRow[2] = newQty.toString();

                await fetch(`${apiUrl}/api/updateRow`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                    body: JSON.stringify({ sheetName: 'Stock', rowIndex: stockData.indexOf(stockItem) + 2, rowData: updatedStockRow }),
                });
            }
        }

        alert(`Solicitud ${action} correctamente.`);
        fetchRequests();
    };
    
    if (loading) return <p>Cargando requerimientos...</p>;

    return (
        <div className="card">
            <h2>Requerimientos de Provisión</h2>
            {requests.length === 0 ? (
                <p>No hay solicitudes pendientes.</p>
            ) : (
                <div className="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>ID Movimiento</th>
                                <th>Fecha y Hora</th>
                                <th>OT Relacionada</th>
                                <th>ID Item</th>
                                <th>Cantidad Solicitada</th>
                                <th>Solicitante</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requests.map((req, index) => (
                                <tr key={index}>
                                    <td>{req[0]}</td>
                                    <td>{req[1]}</td>
                                    <td>{req[2]}</td>
                                    <td>{req[3]}</td>
                                    <td>{req[5]}</td>
                                    <td>{req[6]}</td>
                                    <td>
                                        <button className="success" onClick={() => handleProcessRequest(req[0], 'approved')}>Aprobar</button>
                                        <button className="danger" onClick={() => handleProcessRequest(req[0], 'rejected')}>Rechazar</button>
                                        {/* Aquí iría el botón para "Aprobar con modificaciones" */}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default RequestManagementView;